import { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, useFormik, FormikProvider } from 'formik';
import { visuallyHidden } from '@mui/utils';

// Components
import { FileUploader } from 'components/global/fileUploader';

// Store + Core
import { BATCH_UPLOAD_FILE_TYPES } from 'core/constants';
import { batchLearner, batchLearnerClearAction } from 'store/learner/actions';
import { learnerFileSelector, uploadLearnerPercentageSelector } from 'store/learner/selectors';
import { rollupOrganizationEnumSelector } from 'store/user/selectors';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from 'store';
import { PARSAction } from 'core/models';

// Types
export interface IBatchActivityFormValues {
  file: File;
}

export const BatchLearnerForm = (): ReactElement => {
  const dispatch: ThunkDispatch<AppState, unknown, PARSAction> = useDispatch();

  // Redux State.
  const uploadPercentage: number = useSelector(uploadLearnerPercentageSelector);
  const uploadedFile = useSelector(learnerFileSelector);
  const rollupOrganizationEnum = useSelector(rollupOrganizationEnumSelector);

  const onClearFile = (): void => {
    dispatch(batchLearnerClearAction());
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: (values) => {
      // API call - upload file.
      dispatch(batchLearner({ file: values as { file: File }, rollupOrganizationEnum }));
    },
  });
  const { handleSubmit } = formik;

  return (
    <FormikProvider value={formik}>
      <form encType="multipart/form-data" onSubmit={handleSubmit}>
        <Field
          component={FileUploader}
          fileTypes={BATCH_UPLOAD_FILE_TYPES}
          id="batchLearnerFile"
          showDropZoneSubTitle
          name="file"
          onClearFile={onClearFile}
          uploadedFile={uploadedFile}
          uploadPercentage={uploadPercentage}
        />
        <span style={visuallyHidden}>
          <button tabIndex={-1}>Submit</button>
        </span>
      </form>
    </FormikProvider>
  );
};
